/*
 * @Author: Teemo Ding
 * @Date: 2021-10-28 17:19:47
 * @LastEditTime: 2022-06-08 13:37:01
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/types/common/order.ts
 */

import { SalesChannel } from './SalesChannel';
export enum IFulfillmentStatus {
  NONE = 'NONE',
  OUT_OF_STOCK = 'OUT_OF_STOCK',
  READY_TO_PICK = 'READY_TO_PICK',
  READY_TO_PACK = 'READY_TO_PACK',
  READY_TO_SHIP = 'READY_TO_SHIP',
  READY_TO_COLLECT = 'READY_TO_COLLECT',
  NOTIFIED = 'NOTIFIED',
  DELIVERED = 'DELIVERED',
  PARTIAL_RETURNED = 'PARTIAL_RETURNED',
  COLLECTED = 'COLLECTED',
  RETURNED = 'RETURNED',
  ERROR = 'ERROR',
  DELIVERING = 'DELIVERING',
}

export enum IPaymentStatus {
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  PAID = 'PAID',
  PARTIAL_REFUNDED = 'PARTIAL_REFUNDED',
  PARTIAL_RETURNED = 'PARTIAL_RETURNED',
  REFUND_REQUESTED = 'REFUND_REQUESTED',
  REFUND_APPROVED = 'REFUND_APPROVED',
  REFUNDED_REJECTED = 'REFUNDED_REJECTED',
  RETURNING_IN_PROGRESS = 'RETURNING_IN_PROGRESS',
  RETURN_RECEIVED = 'RETURN_RECEIVED',
  REFUND_CONFIRMED = 'REFUND_CONFIRMED',
  RETURN_DELIVERY_CONFIRMED = 'RETURN_DELIVERY_CONFIRMED',
  REFUND_ERROR = 'REFUND_ERROR',
  REFUNDED = 'REFUNDED',
  NONE = 'NONE',
  RETURN_REQUESTED = 'RETURN_REQUESTED',
  RETURN_CONFIRMED = 'RETURN_CONFIRMED',
  RETURN_APPROVED = 'RETURN_APPROVED',
  RETURN_REJECTED = 'RETURN_REJECTED',
  RETURNED = 'RETURNED',
}

export enum EGiftCardType {
  GiftCard = 'GiftCard',
  StoreCreditCard = 'StoreCreditCard',
}

export enum ESubscriptionBuyStatus {
  Created = 'Created',
  Active = 'Active',
  Cancelled = 'Cancelled',
}

export enum EShoppingCartStatus {
  Active = 'Active',
  Draft = 'Draft',
  Locked = 'Locked',
}

export enum EGiftCardStatus {
  Active = 'Active',
  Expired = 'Expired',
  Used = 'Used',
}

export enum IOrderStatus {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  COMPLETE = 'COMPLETE',
  SUSPENDED = 'SUSPENDED',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  SAVED = 'SAVED',
}

export enum ILogisticsMethod {
  Delivery = 'Delivery',
  ParcelLocker = 'ParcelLocker',
  ClickCollect = 'ClickCollect',
  Digital = 'Digital',
}

export enum AdditionalStatus {
  Requested = 'Requested',
}
export interface OrderList {
  uuid: string;
  orderNo: string;
  orderTime: string;
  paymentTime: string;
  buyerName: string;
  buyerEmail: string;
  buyerPhoneNo: string;
  recipientName: string;
  recipientEmail: string;
  recipientPhoneNo: string;
  currency: string;
  totalPrice: string;
  reportingTotalPrice: string;
  salesChannelUuid: string;
  salesChannelName: string;
  warehouseUuid: string;
  warehouseName: string;
  orderStatus: IOrderStatus;
  paymentStatus: IPaymentStatus;
  fulfillmentStatus: IFulfillmentStatus;
  userRemark: string;
}

export interface OrderListPage {
  orders: any;
  timezoneInGMT: any;
  //   orders: OrderList[];
  salesChannels: SalesChannel[];
  countOfReadyToPick: number;
  countOfReadyToPack: number;
  countOfReadyToShip: number;
  reportingCurrency: string;
}

export enum EType {
  Buy = 'Buy',
  Gift = 'Gift',
  GiftPurchase = 'GiftPurchase',
  Customized = 'Customized',
  'SubscriptionBuyGift' = 'SubscriptionBuyGift',
}

export interface IOrderPackItem {
  uuid: string;
  orderLineItemUuid: string;
  salesChannelProductUuid: string;
  productUuid: string;
  type: EType;
  image; //: Image;
  productName: string;
  productSetName: string;
  sku: string;
  productSetSku: string;
  amount: number;
  totalPrice: number;
  discountPrice: number;
  paidPrice: number;
  customisation;
}

export enum EDeliveryType {
  Delivery = 'Delivery',
  ParcelLocker = 'ParcelLocker',
  ClickCollect = 'ClickCollect',
}

export enum RecipientInfoName {
  FirstName = 'FirstName',
  LastName = 'LastName',
  FullName = 'FullName',
  Email = 'Email',
  MobileNumber = 'MobileNumber',
  TelephoneNumber = 'TelephoneNumber',
  Title = 'Title',
  CompanyName = 'CompanyName',
}

export enum EOperationType {
  Refund = 'Refund',
  Return = 'Return',
}

export enum EOrderReturnsStatus {
  ReturnApproved = 'ReturnApproved',
  RefundConfirmed = 'RefundConfirmed',
  RefundApproved = 'RefundApproved',
  RefundRejected = 'RefundRejected',
  ReturnRejected = 'ReturnRejected',
  ReturnLogisticsConfirmed = 'ReturnLogisticsConfirmed',
  Requested = 'Requested',
  Confirmed = 'Confirmed',
  Approved = 'Approved',
  Rejected = 'Rejected',
  Processing = 'Processing',
  Failed = 'Failed',
  Completed = 'Completed',
  ReturnConfirmed = 'ReturnConfirmed',
}

export enum ETransactionsType {
  Created = 'Created',
  Pending = 'Pending',
  Success = 'Success',
  Fail = 'Fail',
  Cancel = 'Cancel',
}

export enum OrderRefundTransaction {
  Adyen = 'Adyen',
  Atome = 'Atome',
  Stripe = 'Stripe',
  Qfpay = 'Qfpay',
  BankTransfer = 'BankTransfer',
  GiftCard = 'GiftCard',
  NewStoreCredit = 'NewStoreCredit',
  FpsQrCode = 'FpsQrCode',
}
export enum TemplateStatus {
  Active = 'Active',
  Draft = 'Draft',
  Locked = 'Locked',
}

export enum SubscriptionOrderStatus {
  Created = 'Created',
  Active = 'Active',
  Cancelled = 'Cancelled',
}

export enum RefundSummaryType {
  RefundedItems = 'RefundedItems',
  ShippingFee = 'ShippingFee',
  ShippingFeeTax = 'ShippingFeeTax',
  ProductTax = 'ProductTax',
  OrderTax = 'OrderTax',
  Adjustment = 'Adjustment',
  TotalRefund = 'TotalRefund',
  NetPayment = 'NetPayment',
}
